import api from '~services/axios';

export default {
  apiGetClueList: params => api.get('/api/clues/query', { params }),
  apiDeleteClue: params => api.post('/api/clues/delete', params),
  apiGetAllSalesman: params => api.get('/api/clues/queryteamuser', { params }),
  apiSaveSalesman: params => api.post('/api/clues/updateSalesman', params),
  apiAddClue: params => api.post('/api/clues/add', params),
  apiEditClue: params => api.post('/api/clues/update', params),
  apiGetClueDetail: params => api.get('/api/clues/detail', { params }),
  apiChangeClueState: params => api.post('/api/clues/modifyState', params),
  apiSearchCustomer: params => api.get('/api/clues/queryCustomer', { params }),
  apiGetTransferDetail: params => api.get('/api/clues/queryCustomerDetail', { params }),
  apiAddClueCustom: params => api.post('/api/clues/conversionCustomerAdd', params),
  apiConnectToCustom: params => api.post('/api/clues/conversionCustomerSave', params),
  apiGetClueVisit: params => api.get('/api/clues/query/visit', { params }),
};
